import rootApi from '@utils/baseAPI/WrapperApi';

const base = 'api/master-data';

export const apiGetMasterData = (params = {}) => {
  return rootApi.get(base, { params });
};

export const apiCreateMasterData = (data) => {
  return rootApi.post(base, data);
};

export const apiUpdateMasterData = (id, data) => {
  return rootApi.put(`${base}/${id}`, data);
};

export const apiDeleteMasterData = (id) => {
  return rootApi.delete(`${base}/${id}`);
};

export default {
  apiGetMasterData,
  apiCreateMasterData,
  apiUpdateMasterData,
  apiDeleteMasterData
};
